import React from 'react';

const LoopLegendIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.2 62.44"
      className="svg-icon"
   >
      <g id="Layer_2" data-name="Layer 2">
         <g id="Layer_1-2" data-name="Layer 1">
            <path
               className="svg-icon-background"
               d="M11.51,61.85A9.51,9.51,0,0,1,2,52.47L1.5,11a9.52,9.52,0,0,1,9.38-9.62L52.07.9a9.58,9.58,0,0,1,6.75,2.71,9.44,9.44,0,0,1,2.87,6.67l.52,41.44a9.51,9.51,0,0,1-9.38,9.62Z"
            />
            <rect
               className="svg-icon-decoration"
               x="1.5"
               y="9.6"
               width="59.2"
               height="8.18"
            />
            <rect
               className="svg-icon-decoration"
               x="1.5"
               y="27.29"
               width="59.2"
               height="8.18"
            />
            <rect
               className="svg-icon-decoration"
               x="1.5"
               y="44.98"
               width="59.2"
               height="8.18"
            />
            <path d="M51.7,62.44H10.5A10.51,10.51,0,0,1,0,51.94V10.5A10.51,10.51,0,0,1,10.5,0H51.7A10.51,10.51,0,0,1,62.2,10.5V51.94A10.51,10.51,0,0,1,51.7,62.44ZM10.5,3A7.5,7.5,0,0,0,3,10.5V51.94a7.51,7.51,0,0,0,7.5,7.5H51.7a7.52,7.52,0,0,0,7.5-7.5V10.5A7.51,7.51,0,0,0,51.7,3Z" />
            <rect x="10.56" y="1.5" width="3" height="59.44" />
            <rect
               className="svg-icon-highlight"
               x="23.67"
               y="10.97"
               width="19.39"
               height="5.44"
            />
            <path
               className="svg-icon-highlight"
               d="M43.06,17.91H23.67a1.5,1.5,0,0,1-1.5-1.5V11a1.5,1.5,0,0,1,1.5-1.5H43.06a1.5,1.5,0,0,1,1.5,1.5v5.44A1.5,1.5,0,0,1,43.06,17.91Zm-17.89-3H41.56V12.47H25.17Z"
            />
            <rect x="20.14" y="46.35" width="19.39" height="5.44" />
            <path d="M39.53,53.29H20.14a1.5,1.5,0,0,1-1.5-1.5V46.35a1.5,1.5,0,0,1,1.5-1.5H39.53a1.5,1.5,0,0,1,1.5,1.5v5.44A1.5,1.5,0,0,1,39.53,53.29Zm-17.89-3H38V47.85H21.64Z" />
            <rect x="44.8" y="28.45" width="19.39" height="5.53" />
            <path d="M64.19,35.48H44.8A1.5,1.5,0,0,1,43.3,34V28.45A1.5,1.5,0,0,1,44.8,27H64.19a1.5,1.5,0,0,1,1.5,1.5V34A1.5,1.5,0,0,1,64.19,35.48Zm-17.89-3H62.69V30H46.3Z" />
            <rect x="12.06" y="28.45" width="19.39" height="5.53" />
            <path d="M31.45,35.48H12.06a1.5,1.5,0,0,1-1.5-1.5V28.45a1.5,1.5,0,0,1,1.5-1.5H31.45a1.5,1.5,0,0,1,1.5,1.5V34A1.5,1.5,0,0,1,31.45,35.48Zm-17.89-3H30V30H13.56Z" />
         </g>
      </g>
   </svg>
);

export { LoopLegendIcon };
